const guiColors = {
    'motion-primary': '#39c5bb',
    'motion-primary-transparent': '#39c5bbe6',
    'motion-tertiary': '#2c9e96',

    'looks-secondary': '#39c5bb',
    'looks-transparent': '#39c5bb59',
    'looks-light-transparent': '#39c5bb26',
    'looks-secondary-dark': '#2c9e96',

    'extensions-primary': '#39c5bb',
    'extensions-tertiary': '#2c9e96',
    'extensions-transparent': '#39c5bb59',
    'extensions-light': '#8ae3d9',

    'drop-highlight': '#8ae3d9'
};

const blockColors = {
    checkboxActiveBackground: '#39c5bb',
    checkboxActiveBorder: '#2c9e96'
};

export {
    guiColors,
    blockColors
};